export default __webpack_public_path__ + "static/media/ZingProjectH3.53fb9a84.png";